const demosJson = [
  {
    title: "Automating Signals Intelligence Analysis",
    subtitle: "Navy",
    useCase: "Data Fusion, Data Discovery ",
    overviewImage: "/images/CapabilityLocator.jpg",
    image: "/images/Capability Locator/CL1.png",
    imagetext: "",
    linkText: "Continue Reading...",
    benefits: [
      {
        title: "Problem:",
        description:
          "A single log file with 2800+ individual report segments could take over 30 hours for the Electronic Warfare Data System (EWDS) Subject Matter Expert (SME) to manually investigate every report. This introduces a single point of failure and timely delays in execution of critical military operations. Additionally, the current processes introduces a bottleneck due to the level of human engagement required.",
      },
      {
        title: "Solution:",
        description:
          "SAIC worked with the Chief technology SME to break down current process and fully replicate them in a full code manner utilizing the Tenjin platform over the course of 3 days. The new flow processed all 2800+ reports in 10 minutes and identified 12 records that required manual review by the SME. The AI team then reproduced the full-code process in a no-code recipe flow in Tenjin in approximately 45 minutes and achieved identical results. This demonstrated the ability to implement an automated tool chain in customer's secure development environment for streamlining mission analytics and critical inferences. This solution was then demonstrated across the entire EWDS division with positive customer feedback.",
      },
      {
        title: "Outcome:",
        description:
          "The SME not only immediately understood the value and capabilities of the platform but was already talking about other internal tools and processes that could be folded into the platform in to increase the reaction speed of their team and benefits to users in the field. There was an expressed interest across EWDS which identified opportunities for additional use cases across various customers, mission locations, and business units. This also provided an opportunity for the shaping of the program's strategic roadmap. We were able to achieve results that the SME told us he had failed to accomplish in 28 previous attempts, leading the customer to the value of Fixed-Price Projects (FFP) sprints, changing from a labor model to an adoption of outcome-based deliveries.",
      },
      {
        title: "Takeaway:",
        description:
          "Tenjin assisted the EWDS (Electronic Warfare Data System) team in ingesting, fusing, and creating complex data sets which will then be loaded onto platforms in various theaters. Tenjin not only reduced the SME's workload by 99%, but also replicated the SME's workflow in a low-code/no-code automation that is able to be leveraged by EWDS data scientists.",
      },
    ],
    video: "",
    talktrackPdf:
      "https://docs.google.com/presentation/d/1mDkf9W8TR4mc_fN3bO1ZotH7nYK3-d6a/edit?usp=drive_link&ouid=104262004862347650303&rtpof=true&sd=true",
    customerdata:
      "This capability demonstration was initially created to persue a FEDSIM deal with NSIN and NIWC Lant, since then has been shown to a significant number of groups that have aquisition and a need for organizing requirements gathering. These groups include the following yyyy and zzzz including abc, efg, hij, klm. \nTradeshows: xxx, yyy, zzz and kkk.",
    relevantcustomers: "Navy, Army, Air Force, COCOMS, USMC",
    demoLink: "",
    koverseLink: "",
    koverseAccounts: [],
    tenjinLink: "",
    tenjinAccounts: [],
  },
  {
    title: "Localized Language Translation and Key Data Extractions",
    subtitle: "Marine Corps",
    useCase: "Data Fusion, Entity Analysis",
    overviewImage: "/images/ElectronicWarfareFusionCapability.jpg",
    image: "/images/Electronic Warfare (EW) Fusion Capability/EWFC1.png",
    imagetext: "",
    linkText: "Continue Reading...",
    benefits: [
      {
        title: "Problem:",
        description:
          "The workload is often more than the unit can sustain, so information is lost. The workflow seeks optimization to discover and classify entities of interest and how they relate to activities and other entities, a task that is near impossible to complete quickly and efficiently.",
      },
      {
        title: "Solution:",
        description:
          "SAIC utilized the current NLP Accelerator capabilities to create a stand-alone solution that extracted entities, provided language translation, provided analyst ready documents, and allowed the data to be exported to ArcGIS All Source. The AI IF was able to rapidly build a working light weight prototype application built for marine/analyst's workflow. The prototype utilized DCGS data and also ran on similarly specified hardware. SAIC showcased how quickly and accurately a user could process files/data using Natural Language Processing. The team iterated in 2-week sprints with the end government customer and pivoted several times to address key concerns. Additionally, Tenjin Accelerators were leveraged in a standalone windows environment.",
      },
      {
        title: "Outcome:",
        description:
          "This key development effort fostered follow-ons with the DCGS team. SAIC is being tasked for a sole-source contract to expand the capability. Engagements with the customer are still ongoing to potentially expand the prototype and purchase 3 additional Tenjin licenses at the server level. ",
      },
      {
        title: "Takeaway:",
        description:
          "Tenjin’s NLP Prototype empowered DCGS analysts to easily extract entities within their disparate data sources. This capability will reduce the manual work needed today and accelerate how Marines handle field collected data at the source.",
      },
    ],
    video: "",
    talktrackPdf: "",
    customerdata:
      "This capability demonstration was initially created to meet a need from NAVAIRs EWDS Lab at NAS Point Mugu. The capability cut a man data fusion process that previously took 28 days down to 30 seconds. This Demonstation is now a contracted project that SAIC is currently working on that other labs within NAVAIR are interested in. Other customers that have seen this capability include xxx, zzz\nTradeshows: xxx, yyy, zzz and kkk.",
    relevantcustomers: "Navy, Air Force, NIC",
    demoLink: "",
    koverseLink: "",
    koverseAccounts: [],
    tenjinLink: "",
    tenjinAccounts: [],
  },
  {
    title: "Automating Data Fusion for Open-Source Intelligence",
    subtitle: "USASOC",
    useCase: "Supply Chain, Data Discovery, Entity Analysis",
    overviewImage: "/images/DataCentricRiskMitigation.jpg",
    image:
      "/images/Data Centric Risk Mitigation for Supply Chain Management/DCRMSCM1.png",
    imagetext: "",
    linkText: "Continue Reading...",
    benefits: [
      {
        title: "Problem:",
        description:
          "The current processes is extremely repetitive and inhibits analysts from effectively processing the numerous amounts of data captured within the various vendor products. Additionally, the data is not uniform upon ingest or export.​",
      },
      {
        title: "Solution:",
        description:
          "SAIC worked with the lead OSINT SME to review the current tool suite, define mission needs, and create an automated workflow that ingests desired OSINT repositories. The process removed the need for querying multiple data sources while also exporting the data into a standardized format for continued processing. Not only did this reduce the manual labor time, but it reduced the need for continued costs of licensing for commercial tool sets.",
      },
      {
        title: "Outcome:",
        description:
          "The SME received a single repository of data that could be maintained, traced, and adjusted to accurately define military operations in the intended AOR. Additionally, the data was able to continually be enriched and automated, allowing more time for the analysts to conduct target link analysis. Lastly, the data was then able to be exported into a desired standardized format that enabled continued processing to downstream customers. The USASOC customer also demonstrated the capabilities of Tenjin to the FORSCOM customer who expressed a strong desire for a deeper dive of the product. ",
      },
      {
        title: "Takeaway:",
        description:
          "Tenjin enhanced the efficiency of OSINT fusion while automating time-consuming tasks. By streamlining processes and reducing manual effort, Tenjin freed up valuable time for the SMEs to focus on more analytical work.",
      },
    ],
    video: "",
    talktrackPdf:
      "https://docs.google.com/presentation/d/1Lg4g3pl9nsALAdJGuaASs91LC0K5wtpI/edit?usp=drive_link&ouid=104262004862347650303&rtpof=true&sd=true",
    customerdata:
      "This capability demonstration was initially created to meet a need from xxxxxxx and has been shown to the following groups within the yyyy and zzzz including abc, efg, hij, klm.\nTradeshows: xxx, yyy, zzz and kkk.",
    relevantcustomers: "Navy, Army, Air Force, NIC, FEDCIV, COCOMS, USMC",
    demoLink: "",
    koverseLink: "",
    koverseAccounts: [],
    tenjinLink: "",
    tenjinAccounts: [],
  },
  {
    title:
      "Searching through Unstructured Documentation to answer FOIA Requests",
    subtitle: "CENTCOM",

    useCase: "Data Fusion",
    overviewImage: "/images/EntityBasedProductionandMonitoring.jpg",
    image: "/images/Entity Based Production and Monitoring/EBPM1.png",
    imagetext: "",
    linkText: "Continue Reading...",
    benefits: [
      {
        title: "Problem:",
        description:
          "CENTCOM must answer FOIA requests in a timely manner but struggles to manually search through years of PowerPoints, emails with attachments, PDFs, and other unstructured data sources. Current efforts involve increasing manpower with reservists and non-technical users bogging down technical users with basic query asks.​",
      },
      {
        title: "Solution:",
        description:
          "SAIC utilized the C4ES Program and the AI Innovation Factory (AI IF) to work together and craft a meaningful proof-of-concept over a 3-month period. The AI IF was able to rapidly build a working proof-of-concept application built for a FOIA analyst's workflow. Utilizing CENTCOM data from the customer, SAIC showcased how quickly and accurately a user could search through this unstructured data using Natural Language Processing. The team iterated in 2-week sprints with the end government customer and pivoted several times to address key concerns. Additionally, Koverse was leveraged to address a CENTCOM enterprise issue for Multi-Level Security data tagging.",
      },
      {
        title: "Outcome:",
        description:
          "This key development effort fostered follow-ons with the General and CENTCOM digital transformation team leads. SAIC is coming up for recompete on C4ES and can use this as a proof point with the customer. Engagements with the customer are still ongoing to potentially purchase the FOIA prototype.",
      },
      {
        title: "Takeaway:",
        description:
          "Tenjin & Koverse empowered FOIA analysts to easily find content within their disparate data sources, and not just metadata. This capability would reduce the manual work needed today and accelerate how CENTCOM can respond to future FOIA requests.",
      },
    ],
    video: "",
    talktrackPdf: "",
    customerdata:
      "This capability demonstration was initially created to meet a need from DOJ and has been shown to the following groups within the yyyy and zzzz including abc, efg, hij, klm. This Demonstation is now a contracted project that SAIC is currently working.\nTradeshows: xxx, yyy, zzz and kkk.",
    relevantcustomers: "Navy, Army, Air Force, NIC, FEDCIV, COCOMS, USMC",
    demoLink: "",
    koverseLink: "",
    koverseAccounts: [],
    tenjinLink: "",
    tenjinAccounts: [],
  },
  {
    title: "Real-Time DDIL Situational Awareness",
    subtitle: "Army",
    useCase: "Data Fusion",
    overviewImage: "/images/MultiMediaDataManagementLabeling.jpg",
    image: "/images/Multi-Media Data Management and Labeling/MMDML1.png",
    imagetext: "",
    linkText: "Continue Reading...",
    benefits: [
      {
        title: "Problem:",
        description:
          "While IoT sensors provide valuable real-time data, the lack of AI/ML models hampers the ability of warfighters to derive actionable insights, optimize decision-making, and enhance situational awareness. Without AI/ML models trained in specific mission environments, warfighters are unable to effectively anticipate threats, optimize resource allocation, and adapt to rapidly changing scenarios.",
      },
      {
        title: "Solution:",
        description:
          "SAIC developed a data-driven mesh environment consisting of dismounts, sensor emplacements, vehicles, and a fixed command post with U.S. and simulated coalition workstations. All capabilities were enhanced with AI, which were evolved and improved iteratively over 2 days with streaming data from deployed sensors. All data was processed via rugged hardware and networking components in the field.",
      },
      {
        title: "Outcome:",
        description:
          "This demonstration emphasized the operator-friendly nature of our solutions, highlighting the ease of use through no-code tools. Our solution also enabled the rapid creation of AI models in the field without special hardware, cloud, or network requirements. Through the instantiation of a data-driven mesh environment, SAIC was able to support early warning, force protection, and mission survivability scenarios.",
      },
      {
        title: "Takeaway:",
        description:
          "Tenjin enabled the near-real-time data aggregation, data convergence, and Continuity of Cperations (COOP) in a Distributed, Disconnected, Intermittent, and Limited (DDIL) environment.",
      },
    ],
    video: "",
    talktrackPdf: "Pending",
    customerdata:
      "This capability demonstration was initially created to meet a need from the 1st Capabilities Integration Group (1CIG) and uses their video data within our demo. been shown to the following groups within the yyyy and zzzz including abc, efg, hij, klm.Tradeshows: xxx, yyy, zzz and kkk.",
    relevantcustomers: "Navy, Army, Air Force, NIC, FEDCIV, COCOMS, USMC",
    demoLink: "",
    koverseLink: "",
    koverseAccounts: [],
    tenjinLink: "",
    tenjinAccounts: [],
  },
  {
    title: "Generating SAIC Responses to RFIs",
    subtitle: "Internal",

    useCase: "Data Fusion",
    overviewImage: "/images/HealthcareDataFusion.jpg",
    image: "/images/HealthcareDataFusion.jpg",
    imagetext: "",
    linkText: "Continue Reading...",
    benefits: [
      {
        title: "Problem:",
        description:
          "Stakeholders find it difficult to effectively source the best-fit reference materials at scale when writing responses and/or proposals. Further, their workflow could be better streamlined by a tool that uses generative AI to facilitate common tasks such as requirements gathering, refining language, checking responses for consistency and completeness, and so on.",
      },
      {
        title: "Solution:",
        description:
          "SAIC proved out a repeatable framework centered around Retrieval-Augmented Generation (RAG), used to gather the most relevant and up-to-date sections of documents when given a set of natural-language requirements. This backed a user-facing application which carried stakeholders through a step-by-step workflow, beginning with a Request for Information (RFI) and ending with an early draft enriched with source materials.",
      },
      {
        title: "Outcome:",
        description:
          "Once the application is fully built out and in the hands of a wider group of users, it is anticipated this will reduce the amount of time spent manually scanning internal documents and generating early drafts. Building this functionality in-house ensures unique stakeholder needs are met, and it also ensures the security of valuable company data.",
      },
      {
        title: "Takeaway:",
        description:
          "Tenjin streamlines the proposal writing process by retrieving relevant source materials and generating early draft responses. This reduces manual effort and safeguards valuable company data, ensuring efficiency and security in responding to customer requests.",
      },
    ],
    video: "",
    talktrackPdf: "",
    customerdata:
      "This capability demonstration is in backlog and development to meet a need from xxxxxxx and has been shown to the following groups within the yyyy and zzzz including abc, efg, hij, klm.\nTradeshows: xxx, yyy, zzz and kkk.",
    relevantcustomers: "FEDCIV",
    demoLink: "",
    koverseLink: "",
    koverseAccounts: [],
    tenjinLink: "",
    tenjinAccounts: [],
  },
  {
    title:
      "AI-Assisted Bill of Materials Generation from Technical Data Packages",
    subtitle: "Navy/Engineering",

    useCase: "Data Discovery ",
    overviewImage: "/images/MissileInformationCrossSearch.jpg",
    image: "/images/Data Management and Search Analytic/DMSA1.png",
    imagetext: "",
    linkText: "Continue Reading...",
    benefits: [
      {
        title: "Problem:",
        description:
          "Engineers spend days manually reviewing Technical Design Packages (TDPs) to create a Bill of Materials (BoM).  There is a need to expedite the BoM Generation process in order to provide speed to market, efficiency, and consistency across the various documents.",
      },
      {
        title: "Solution:",
        description:
          "SAIC installed Tenjin in the DE ecosystem, ReadyOne, to demonstrate AI/ML capabilities that reliably extract text from structured and unstructured data sources that can then be used to repeatably generate a BoM in multiple formats for use by engineers.",
      },
      {
        title: "Outcome:",
        description:
          "This key development effort is to demonstrate the ability to ingest TDPs and create an auto-generated Bill of Materials (BoM).",
      },
      {
        title: "Takeaways:",
        description:
          "Tenjin empowers engineers to automate the TDP review process and to generate a Bill of Materials in hours, rather than days.",
      },
    ],
    video: "",
    talktrackPdf:
      "talk track: https://drive.google.com/drive/folders/1mUGn7lO2NVLqp9Z5rMnTABPwr5UrzLVr       click track: https://drive.google.com/drive/folders/1mUGn7lO2NVLqp9Z5rMnTABPwr5UrzLVr",
    customerdata:
      "This capability demonstration was initially created to meet a need from MDA. This is a staple search capability and is generic to show to almost any client that wants to see Koverse. It has been shown to the following groups within the yyyy and zzzz including abc, efg, hij, klm.\nTradeshows: xxx, yyy, zzz and kkk.",
    relevantcustomers: "Navy, Army, Air Force, NIC, FEDCIV, COCOMS, USMC",
    demoLink: "",
    koverseLink: "",
    koverseAccounts: [],
    tenjinLink: "",
    tenjinAccounts: [],
  },
  {
    title: "Databricks & Tenjin",
    subtitle: "A Love Story for the Enterprise- AFDODAC",
    useCase: "Document Management ",
    overviewImage: "/images/Redactor.png",
    image: "/images/Redactor.png",
    imagetext: "",
    linkText: "Continue Reading...",
    benefits: [
      {
        title: "Problem:",
        description:
          "CDAO needs an easy to use, intuitive platform that can provide rapid onboarding. These new users bring their own datasets which require additional tagging and micro-segmentation of data to preserve the security of the data which does not exist in their current ADVANA platform.",
      },
      {
        title: "Solution:",
        description:
          "SAIC integrated their Tenjin AI/ML platform and Databricks to create an end-to-end data science suite that is designed to support both non-technical and highly technical users alike. By joining Tenjin with Databricks, it was possible to leverage seamless compute from Tenjin through Databricks orchestration of Apache Spark for distributed processing jobs for training ML models. In-platform self-service tutorials were developed to quickly onboard new users without the need of extensive training. Adding data governance and MLOps pipelines to deploy, monitor, and refine machine learning models allowed for some of the missing gaps with the current platform.",
      },
      {
        title: "Outcome:",
        description:
          "This approach will transform the current ADVANA data lake into an attribute-based architecture to enable future advancements in data governance and AI models. The Tenjin platform has simplified the user experience with its low/no code interface by empowering citizen data scientists to create and utilize machine learning models and flows.",
      },
      {
        title: "Automated data labeling and metadata management will:",
        description:
          "1). Enable current and future AI/ML algorithms 2).Improve efficiency and accuracy of data cataloging 3). Allow for flexible, automated governance oversight for security, compliance and accuracy",
      },
      {
        title: "Takeaway:",
        description:
          "Tenjin's no-code development platform bridges the gap between non-technical and technical contributors using the existing infrastructure.",
      },
    ],
    video: "",
    talktrackPdf: "",
    customerdata:
      "This capability demonstration was initially created to meet a need from DE Groups and has been shown to the following groups within the yyyy and zzzz including abc, efg, hij, klm.\nTradeshows: xxx, yyy, zzz and kkk.",
    relevantcustomers: "Navy, Army, Air Force, NIC, FEDCIV, COCOMS, USMC",
    demoLink: "",
    koverseLink: "",
    koverseAccounts: [],
    tenjinLink: "",
    tenjinAccounts: [],
  },
];

export default demosJson;
